import type { MonitoringOverview } from '../../../services/dmMonitoringOverview';
import { eventTypeLabel } from './overviewFormat';
import { EVENT_TYPE_TOP_COUNT, OTHER_EVENT_TYPES_LEGEND, rankedSliceTone } from './overviewLegend';
import type { HistoryView } from './overviewPeriod';
import type { PieSlice } from './OverviewDonut';
import { takeTopByCount } from './overviewSlices';
import { NotificationBreakdownCard } from './NotificationBreakdownCard';

const OTHER_TYPES_KEY = 'other-types';
const TOP_NOTE = `The ${EVENT_TYPE_TOP_COUNT} most common are shown, the rest grouped as Other types.`;
const INFO = {
    open: `Open DM notifications by event type. ${TOP_NOTE}`,
    range: `Every notification DM raised in the range, open or resolved, by event type. ${TOP_NOTE}`
} as const;

function eventTypeSlices(eventTypes: MonitoringOverview['eventTypes']): PieSlice[] {
    const { top, restCount } = takeTopByCount(eventTypes, EVENT_TYPE_TOP_COUNT);
    const ranked = top.map((entry, rank) => ({
        key: entry.eventType,
        count: entry.count,
        label: eventTypeLabel(entry.eventType),
        ...rankedSliceTone(rank)
    }));
    if (restCount === 0) return ranked;
    return [...ranked, { key: OTHER_TYPES_KEY, count: restCount, ...OTHER_EVENT_TYPES_LEGEND }];
}

interface EventTypesCardProps {
    eventTypes: MonitoringOverview['eventTypes'];
    history: HistoryView;
}

export function EventTypesCard({ eventTypes, history }: EventTypesCardProps) {
    const raised = history.data?.raised.eventTypes;
    return (
        <NotificationBreakdownCard
            title="Notifications by type"
            info={INFO}
            openSlices={eventTypeSlices(eventTypes)}
            rangeSlices={raised ? eventTypeSlices(raised) : null}
            history={history}
        />
    );
}
